module.exports = __webpack_public_path__ + "static/media/video.787fdb36.jpg";